import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "item-listing" }
const _hoisted_2 = {
  key: 1,
  class: "bulk-operation-listing-header"
}
const _hoisted_3 = { class: "inline-flex align-items-center" }
const _hoisted_4 = { class: "width100" }
const _hoisted_5 = { class: "main-heading primary-heading" }
const _hoisted_6 = { class: "inline-flex" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 3,
  class: "select-all-checkbox-position"
}
const _hoisted_11 = { class: "inline-flex" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "description font-weight-600" }
const _hoisted_14 = {
  key: 4,
  class: "text-center"
}
const _hoisted_15 = ["index"]
const _hoisted_16 = {
  key: 0,
  class: "dateSeparator"
}
const _hoisted_17 = { class: "inline-flex100" }
const _hoisted_18 = { class: "inline-flex" }
const _hoisted_19 = { class: "select-program-checkbox margin-left-15" }
const _hoisted_20 = ["id", "value", "disabled", "onClick"]
const _hoisted_21 = { class: "time-programtitle description" }
const _hoisted_22 = { class: "time" }
const _hoisted_23 = { class: "margin-left-5" }
const _hoisted_24 = { class: "programTitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      "show-loading": _ctx.showLoading,
      "border-color": _ctx.loaderBorderColor
    }, null, 8, ["show-loading", "border-color"]),
    (_ctx.modalPopupVisible)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 0,
          "show-modal-popup": _ctx.modalPopupVisible,
          "header-content": _ctx.$t('AddToPrograms'),
          "body-heading": _ctx.modalPopupHeading,
          "body-content": _ctx.modalPopupContent,
          "show-close-button": _ctx.showCloseButton,
          onConfirmClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.AssignProgramsToSelectedEvaluationQuestionsConfirmed($event)))
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-close-button"]))
      : _createCommentVNode("", true),
    (_ctx.isBulkOperation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "btn btn-secondary btn-size-default",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Cancel()))
            }, _toDisplayString(_ctx.$t("CancelButton")), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("EvaluationQuestions.AddFollowingProgramItems")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              disabled: _ctx.programItems.length === 0,
              class: "btn btn-primary btn-size-default",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.AssignProgramsToSelectedEvaluationQuestions()))
            }, _toDisplayString(_ctx.$t("SaveButton")), 9, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isBulkOperation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_ctx.programItems.length>0)
            ? (_openBlock(), _createElementBlock("label", _hoisted_9, _toDisplayString(_ctx.$t("Linkedto")) + " " + _toDisplayString(_ctx.selectedPrograms.length) + " " + _toDisplayString(_ctx.$t("ProgramItems")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.programItems.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("label", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAllProgramItemsCheckbox) = $event)),
              type: "checkbox",
              class: "largerCheckbox",
              disabled: _ctx.disableAllProgramItems
            }, null, 8, _hoisted_12), [
              [_vModelCheckbox, _ctx.selectAllProgramItemsCheckbox]
            ]),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("SelectAll")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("Program.NoProgramExists")), 1)
        ])),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.programItems, (programItem, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: programItem.Id,
        index: index
      }, [
        (_ctx.drawDate(index))
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("label", null, _toDisplayString(_ctx.formatDate(programItem)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                id: 'pi_' + programItem.Id,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPrograms) = $event)),
                type: "checkbox",
                class: "largerCheckbox",
                value: programItem,
                disabled: _ctx.disableAllProgramItems,
                onClick: ($event: any) => (_ctx.checkProgramItems(programItem,index,$event))
              }, null, 8, _hoisted_20), [
                [_vModelCheckbox, _ctx.selectedPrograms]
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatTime(programItem)) + " -", 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(programItem.Title), 1)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))
              ])
            ])
          ])
        ])
      ], 8, _hoisted_15))
    }), 128))
  ]))
}